var global = require('../internals/global');
var String = global.String;
module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};